import enabledStatus from './enabledStatus'
import panelFormUi from './panel-form-ui'
import panelTitle from './panel-title'

export default {
    title: 'Trend radar panel management',
    enabledStatus,
    panelTitle,
    panelFormUi
}
